import config from './config';
import schema from "./schema"
import Repository from "./repository"
import model from "@/services/resources/model";

export default () => {
    return {
        config,
        schema,
        repository: Repository.make(model(config), schema)
    }
};
